import { consts } from "../actions/abilityToCompete";

const initialState = {
    //customer group get
      customerSegmentFetching: false,
      customerSegmentFetched: false,
      customerSegmentData: {},
      customerSegmentError: null,
      competeFetching: false,
      competeFetched: false,
      competeData: {},
      competeDataError: null,

      benefitsFetching: false,
      benefitsFetched: false,
      benefitsData: {},
      benefitsDataError: null,
      challengeStatementData: {},
      challengeStatementFetching: false,
      challengeStatementFetched: false,
      createAbilityOfCompeteData: {},
      createAbilityOfCompeteFetching: false,
      createAbilityOfCompeteFetched: false,
      competitorsGroupsFetching: false,
      competitorsGroupsFetched: false,
      competitorsGroupsData: {},

}

export default function reducer(state = initialState, action) {
    switch (action.type) {

      case 'GET_CUSTOMER_SEGMENT_PENDING' : {
        state = Object.assign({}, state, {customerSegmentFetching: true, customerSegmentFetched: false});
        break;
      }
      case "GET_CUSTOMER_SEGMENT_FULFILLED": {
          state = Object.assign({}, state, { customerSegmentFetching: false, customerSegmentFetched: true, customerSegmentData: action.data});
          break;
      }
      case 'GET_CUSTOMER_SEGMENT_REJECT': {
        state = Object.assign({}, state, { customerSegmentFetching: false, customerSegmentFetched: false, customerSegmentData:{},customerSegmentError: action.error });
        break;
      }

      case 'GET_COMPETE_PENDING' : {
        state = Object.assign({}, state, {competeFetching: true, competeFetched: false});
        break;
      }
      case "GET_COMPETE_FULFILLED": {
          state = Object.assign({}, state, { competeFetching: false, competeFetched: true, competeData: action.data});
          break;
      }
      case 'GET_COMPETE_REJECTED': {
        state = Object.assign({}, state, { competeFetching: false, competeFetched: false, competeData:{},competeDataError: action.error });
        break;
      }

      case 'GET_BENEFITS_PENDING' : {
        state = Object.assign({}, state, {benefitsFetching: true, benefitsFetched: false});
        break;
      }
      case "GET_BENEFITS_FULFILLED": {
          state = Object.assign({}, state, { benefitsFetching: false, benefitsFetched: true, benefitsData: action.data});
          break;
      }
      case 'GET_BENEFITS_REJECTED': {
        state = Object.assign({}, state, { benefitsFetching: false, benefitsFetched: false, benefitsData:{},benefitsDataError: action.error });
        break;
      }

      case 'GET_CHALLENGE_STATEMENT_PENDING' : {
        state = Object.assign({}, state, {challengeStatementFetching: true, challengeStatementFetched: false});
        break;
      }
      case "GET_CHALLENGE_STATEMENT_FULFILLED": {
          state = Object.assign({}, state, { challengeStatementFetching: false, challengeStatementFetched: true, challengeStatementData: action.data});
          break;
      }
      case 'GET_CHALLENGE_STATEMENT_REJECTED': {
        state = Object.assign({}, state, { challengeStatementFetching: false, challengeStatementFetched: false, challengeStatementData:{},challengeStatementError: action.error });
        break;
      }

      case 'CREATE_ABILITY_OF_COMPETE_PENDING' : {
        state = Object.assign({}, state, {createAbilityOfCompeteFetching: true, createAbilityOfCompeteFetched: false});
        break;
      }
      case "CREATE_ABILITY_OF_COMPETE_FULFILLED": {
          state = Object.assign({}, state, { createAbilityOfCompeteFetching: false, createAbilityOfCompeteFetched: true, createAbilityOfCompeteData: action.data});
          break;
      }
      case 'CREATE_ABILITY_OF_COMPETE_REJECTED': {
        state = Object.assign({}, state, { createAbilityOfCompeteFetching: false, createAbilityOfCompeteFetched: false, createAbilityOfCompeteData:{}, createAbilityOfCompeteError: action.error });
        break;
      }

      case 'GET_COMPETITORS_GROUPS_PENDING' : {
        state = Object.assign({}, state, {competitorsGroupsFetching: true, competitorsGroupsFetched: false,competitorsGroupsData:{}});
        break;
      }
      case "GET_COMPETITORS_GROUPS_FULFILLED": {
          state = Object.assign({}, state, { competitorsGroupsFetching: false, competitorsGroupsFetched: true, competitorsGroupsData: action.data});
          break;
      }
      case 'GET_COMPETITORS_GROUPS_REJECTED': {
        state = Object.assign({}, state, { competitorsGroupsFetching: false, competitorsGroupsFetched: false, competitorsGroupsData:{}, createAbilityOfCompeteError: action.error });
        break;
      }
      case consts.COMPETE_RESET: {
        return initialState
        break;
      }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/abilityToCompeteReducer.jsx